import cx from "classnames";
import { FC } from "react";

export const NoScores: FC<{ className?: string }> = ({ className }) => (
  <div className={cx("mb-4 px-3 font-italic font-weight-light", className)}>
    No scores in this class
  </div>
);
